import { CalendarState, CellStatusEnum } from "./calendar-state";
import { CalendarVerifier, CalendarVerificationResult} from "./calendar-verifier";
import { UndoRedoElement, UndoStack } from "./undo-stack";

// handles all the shits?
export class InnerCalendarContainer {
    
    levelConfig;
    calendarState;

    constructor(levelConfig) {
        this.levelConfig = levelConfig;

        this.calendarState = new CalendarState(levelConfig);

        this.calendarVerifier = new CalendarVerifier();

        this.undoStack = new UndoStack();

        // feels weird to generate stuff in construct...but w/e?
        this.#generateElements();

        var calVerificationResult = this.calendarVerifier
          .getCalendarVerificationResult(this.levelConfig, this.calendarState);

        // refresh render? check state?
        this.refreshRender(calVerificationResult);

        this.onSolvedFunc = null;
    }

    onCellLeftClicked(i,j) {
        // check game state here? or just disable all buttons?
        // calendarState...
        const cellClicked = this.calendarState.cellGrid[i][j];

        const self = this;

        let applyFunc;
        let undoFunc;

        const prevWasOcc = this.calendarState.cellGrid[i][j].cellStatus === CellStatusEnum.occupied;

        // set to unoccupied
        if (cellClicked.cellStatus === CellStatusEnum.occupied) {
            applyFunc = function() {
                cellClicked.cellStatus = CellStatusEnum.unoccupied;

                var calVerificationResult = self.calendarVerifier
                    .getCalendarVerificationResult(self.levelConfig, self.calendarState);
      
                // check before the refresh? maybe that will help
                if (calVerificationResult.isVerified) {
                    // DISABLE BUTTONS AND UNDO STACK!
                    self.onSolvedFunc();
                }
        
                self.refreshRender(calVerificationResult);

            };

            undoFunc = function() {
                cellClicked.cellStatus = CellStatusEnum.occupied;

                var calVerificationResult = self.calendarVerifier
                    .getCalendarVerificationResult(self.levelConfig, self.calendarState);
      
                // check before the refresh? maybe that will help
                if (calVerificationResult.isVerified) {
                    // DISABLE BUTTONS AND UNDO STACK!
                    self.onSolvedFunc();
                }
        
                self.refreshRender(calVerificationResult);

            }
        }
        // set to occupied
        else {
            const prevCellStatus = cellClicked.cellStatus;

            applyFunc = function() {
                cellClicked.cellStatus = CellStatusEnum.occupied;

                var calVerificationResult = self.calendarVerifier
                    .getCalendarVerificationResult(self.levelConfig, self.calendarState);
      
                // check before the refresh? maybe that will help
                if (calVerificationResult.isVerified) {
                    // DISABLE BUTTONS AND UNDO STACK!
                    self.onSolvedFunc();
                }
        
                self.refreshRender(calVerificationResult);

            };

            undoFunc = function() {
                cellClicked.cellStatus = CellStatusEnum.prevCellStatus;

                var calVerificationResult = self.calendarVerifier
                    .getCalendarVerificationResult(self.levelConfig, self.calendarState);
      
                // check before the refresh? maybe that will help
                if (calVerificationResult.isVerified) {
                    // DISABLE BUTTONS AND UNDO STACK!
                    self.onSolvedFunc();
                }
        
                self.refreshRender(calVerificationResult);

            }
        }

        applyFunc();

        const cellEl = this.cellGridElements[i][j];

        const affectedOtherDateEls = this.getAffecterOtherDateEls(i, j);


        affectedOtherDateEls.forEach(el => {
            el.setAttribute('data-animation', 'pop-occ');

            if (el.querySelector('.occupied-overlay') != null) {
                el.querySelector('.occupied-overlay').setAttribute('data-animation', 'pop');
            }

            if (el.querySelector('.rest-label') != null) {
                el.querySelector('.rest-label').setAttribute('data-animation', 'pop');
            }
        });

        const popType = prevWasOcc
          ? 'pop-rest'
          : 'pop-occ';

        cellEl.setAttribute('data-animation', popType);


        if (cellEl.querySelector('.occupied-overlay') != null) {

            cellEl.querySelector('.occupied-overlay').setAttribute('data-animation', 'pop');

        }

        if (cellEl.querySelector('.rest-label') != null) {
            cellEl.querySelector('.rest-label').setAttribute('data-animation', 'pop');
        }

        const undoRedoElement = new UndoRedoElement(undoFunc, applyFunc);

        this.undoStack.addUndoRedoElement(undoRedoElement);

        /*
        // todo..implement undo

        var calVerificationResult = this.calendarVerifier
          .getCalendarVerificationResult(this.levelConfig, this.calendarState);

        // check before the refresh? maybe that will help
        if (calVerificationResult.isVerified) {
            // DISABLE BUTTONS AND UNDO STACK!
            this.onSolvedFunc();
        }

        this.refreshRender(calVerificationResult);
        */


    }

    onCellRightClicked(i,j) {

        const cellClicked = this.calendarState.cellGrid[i][j];

        const self = this;

        let applyFunc;
        let undoFunc;

        const prevCellStatus = cellClicked.cellStatus;

        // set to unoccupied
        if (cellClicked.cellStatus === CellStatusEnum.rest) {
            applyFunc = function() {
                cellClicked.cellStatus = CellStatusEnum.unoccupied;

                var calVerificationResult = self.calendarVerifier
                  .getCalendarVerificationResult(self.levelConfig, self.calendarState);

                  // check before the refresh? maybe that will help
                if (calVerificationResult.isVerified) {
                    // DISABLE BUTTONS AND UNDO STACK!
                    self.onSolvedFunc();
                }

                self.refreshRender(calVerificationResult);
            }

            undoFunc = function() {
                cellClicked.cellStatus = prevCellStatus;

                var calVerificationResult = self.calendarVerifier
                  .getCalendarVerificationResult(self.levelConfig, self.calendarState);

                   // check before the refresh? maybe that will help
                if (calVerificationResult.isVerified) {
                    // DISABLE BUTTONS AND UNDO STACK!
                    self.onSolvedFunc();
                }

                self.refreshRender(calVerificationResult);

            }
            //cellClicked.cellStatus = CellStatusEnum.unoccupied;
        }
        // set to rest
        else {
            applyFunc = function() {
                cellClicked.cellStatus = CellStatusEnum.rest;

                var calVerificationResult = self.calendarVerifier
                  .getCalendarVerificationResult(self.levelConfig, self.calendarState);

                    // check before the refresh? maybe that will help
                if (calVerificationResult.isVerified) {
                    // DISABLE BUTTONS AND UNDO STACK!
                    self.onSolvedFunc();
                }

                self.refreshRender(calVerificationResult);
            }

            undoFunc = function() {
                cellClicked.cellStatus = prevCellStatus;

                var calVerificationResult = self.calendarVerifier
                  .getCalendarVerificationResult(self.levelConfig, self.calendarState);

                  // check before the refresh? maybe that will help
                if (calVerificationResult.isVerified) {
                    // DISABLE BUTTONS AND UNDO STACK!
                    self.onSolvedFunc();
                }

                self.refreshRender(calVerificationResult);
            }
        }

        applyFunc();

        // only split stuff if this was previous occupied
        if (prevCellStatus === CellStatusEnum.occupied) {
            const cellEl = this.cellGridElements[i][j];

            const affectedOtherDateEls = this.getAffecterOtherDateEls(i, j);

            affectedOtherDateEls.forEach(el => {
                el.setAttribute('data-animation', 'pop-occ');

                if (el.querySelector('.occupied-overlay') != null) {
                    el.querySelector('.occupied-overlay').setAttribute('data-animation', 'pop');
                }

                if (el.querySelector('.rest-label') != null) {
                    el.querySelector('.rest-label').setAttribute('data-animation', 'pop');
                }
            });

        }

        

        /*
        cellEl.setAttribute('data-animation', 'pop-rest');

        if (cellEl.querySelector('.occupied-overlay') != null) {
            cellEl.querySelector('.occupied-overlay').setAttribute('data-animation', 'pop');
        }

        if (cellEl.querySelector('.rest-label') != null) {
            cellEl.querySelector('.rest-label').setAttribute('data-animation', 'pop');
        }
        */
        

        const undoRedoElement = new UndoRedoElement(undoFunc, applyFunc);

        this.undoStack.addUndoRedoElement(undoRedoElement);
    }

    getAffecterOtherDateEls(i, j) {
        let affectedDateEls = [ ];

        // go left first..
        let curIJ = j <= 0
            ? { i: i-1, j: 6}
            : { i: i, j: j-1};


        while ( curIJ.i >= 0
            && (this.calendarState.cellGrid[curIJ.i][curIJ.j].cellStatus === CellStatusEnum.occupied)) {

            affectedDateEls.push(this.cellGridElements[curIJ.i][curIJ.j]);

            if (curIJ.j > 0) {
                curIJ.j--;
            }
            else {
                curIJ.i--;
                curIJ.j = 6;
            }
        }

        curIJ = j < 6
            ? { i: i, j: j+1}
            : { i: i+1, j: 0};

        // first check to ensure we don't add something out of bounds
        while (curIJ.i < 5
            && (this.calendarState.cellGrid[curIJ.i][curIJ.j].cellStatus === CellStatusEnum.occupied)) {

            affectedDateEls.push(this.cellGridElements[curIJ.i][curIJ.j]);

            if (curIJ.j >= 6) {
                curIJ.i++;
                curIJ.j = 0;
            }
            else {
                curIJ.j++;
            }
        }

        return affectedDateEls;
    }

    disableInteractions() {
        this.undoStack.canInteract = false;

        for (let i = 0; i < 5; i++) {
            for (let j = 0; j < 7; j++) {
                let cellEl = this.cellGridElements[i][j];

                cellEl.classList.add('date-game-done');
            }
        }
    }

    refreshRender(calVerificationResult) {
        // first the grid stuff!

        // startSegment...
        let startSegIJ = { i: -1, j: -1 };
        let curEndSegIJ = { i: -1, j: -1 };
        for (let i = 0; i < 5; i++) {
            
            for (let j = 0; j < 7; j++) {
                const cellEl = this.cellGridElements[i][j];
                const cellState = this.calendarState.cellGrid[i][j];

                cellEl.setAttribute('data-cell-status', cellState.cellStatus); 

                if (cellState.cellStatus === CellStatusEnum.occupied) {                    
                    // if startSeg is unset
                    if (startSegIJ.i === -1 && startSegIJ.j === -1) {
                        startSegIJ.i = i;
                        startSegIJ.j =j;
                    }

                    curEndSegIJ.i = i;
                    curEndSegIJ.j = j;
                }
                // if not occupied
                else {
                    const occupiedChildEl = cellEl.querySelector('.occupied-overlay');

                    if (occupiedChildEl != null && !occupiedChildEl.hidden) {
                        occupiedChildEl.hidden = true;
                        //occupiedChildEl.remove();
                    }

                    if (!(startSegIJ.i === -1 && startSegIJ.j === -1)) {
                        this.#tryRenderSegment(startSegIJ, curEndSegIJ);

                        startSegIJ.i = -1;
                        startSegIJ.j = -1;

                        curEndSegIJ.i = -1;
                        curEndSegIJ.j = -1;
                    }
                }

                const restChildEl = cellEl.querySelector('.rest-label');
                if ((restChildEl != null && !restChildEl.hidden) 
                  && cellState.cellStatus !== CellStatusEnum.rest) {
                    restChildEl.hidden = true;
                    //restChildEl.remove();
                }

                if (restChildEl == null && cellState.cellStatus === CellStatusEnum.rest) {
                    const restLabelEl = document.createElement('div');
                    restLabelEl.classList.add('rest-label');
                    restLabelEl.textContent = 'Zz';

                    restLabelEl.addEventListener('animationend', (ev) => restLabelEl.setAttribute('data-animation', 'idle'));


                    // todo...add event listener here! as well as in generate elems

                    cellEl.appendChild(restLabelEl);
                }
                else if (restChildEl != null
                    && restChildEl.hidden
                    && cellState.cellStatus === CellStatusEnum.rest) {

                    restChildEl.hidden = false;
                }
            }
        }
        
        //TRY TO RENDER THE LAST SEGMENT (e.g. if last cell is occupied)
        if (!(startSegIJ.i === -1 && startSegIJ.j === -1)) {
            this.#tryRenderSegment(startSegIJ, curEndSegIJ);
        }


        //then the constraints! day of week
        for (var i = 0; i < 7; i++) {
            var dayOfWeekHint = this.levelConfig.dayOfWeekHintsArr[i];

            if (dayOfWeekHint != null) {
                const dayOfWeekHintEl = this.dayOfWeekHintsElArr[i];

                if (calVerificationResult.satisfiedDayOfWeekIndices.includes(i)) {

                    if (dayOfWeekHintEl.classList.contains('unsatisfied-hint')) {
                        dayOfWeekHintEl.classList.remove('unsatisfied-hint');
                    }
                }
                else {

                    if (!dayOfWeekHintEl.classList.contains('unsatisfied-hint')) {
                        dayOfWeekHintEl.classList.add('unsatisfied-hint');
                    }
                }
            }
        }

        // week hints
        for (var i = 0; i < 7; i++) {
            // necessary for null (unspecified check)..could be property I guess
            var weekHint = this.levelConfig.weekHintsArr[i];

            if (weekHint != null) {
                const weekHintEl = this.weekHintsElArr[i];

                if (calVerificationResult.satisfiedWeekIndices.includes(i)) {

                    if (weekHintEl.classList.contains('unsatisfied-hint')) {
                        weekHintEl.classList.remove('unsatisfied-hint');

                    }
                }
                else {

                    if (!weekHintEl.classList.contains('unsatisfied-hint')) {
                        weekHintEl.classList.add('unsatisfied-hint');
                    }
                }
            }
        }
    }

    #tryRenderSegment(startSegIJ, curEndSegIJ) {
        
        if (!(startSegIJ.i === -1 && startSegIJ.j === -1)) {
            let segI = startSegIJ.i;
            let segJ = startSegIJ.j;

            while (segI < curEndSegIJ.i 
                || (segI === curEndSegIJ.i && segJ <= curEndSegIJ.j)) {
                
                const segCellIJ = this.cellGridElements[segI][segJ];

                let segOccupiedChildEl = segCellIJ.querySelector('.occupied-overlay');

                // handle button here!
                if (segOccupiedChildEl == null) {
                    // first add base element
                    const occupiedOverlayEl = document.createElement('div');
                    occupiedOverlayEl.classList.add('occupied-overlay');

                    occupiedOverlayEl.addEventListener('animationend', (ev) => occupiedOverlayEl.setAttribute('data-animation', 'idle'));


                    segCellIJ.appendChild(occupiedOverlayEl);

                    segOccupiedChildEl = occupiedOverlayEl;
                }

                segOccupiedChildEl.hidden = false;
                
                if (segI === startSegIJ.i && segJ === startSegIJ.j) {
                    // check if single piece? or just add front? two classes?
                    // perhaps midpiece is default...and we have start-end and back-end
                    if (!segOccupiedChildEl.classList.contains('event-front')) {
                        segOccupiedChildEl.classList.add('event-front');
                    }
                }
                else {
                    if (segOccupiedChildEl.classList.contains('event-front')) {
                        segOccupiedChildEl.classList.remove('event-front');
                    }
                }

                if (segI === curEndSegIJ.i && segJ === curEndSegIJ.j) {
                    if (!segOccupiedChildEl.classList.contains('event-back')) {
                        segOccupiedChildEl.classList.add('event-back');
                    }
                }
                else {
                    if (segOccupiedChildEl.classList.contains('event-back')) {
                        segOccupiedChildEl.classList.remove('event-back');
                    }
                }

                if (segJ === 6) {
                    segI++;
                    segJ = 0;
                } else {
                    segJ++;
                }
            }
        }
    }


    // this could be render stuff...
    #generateElements() {
        // calendarState...

        this.#generateDayOfWeekLabels();

        this.#generateCellGridElements();

        this.#generateEdgeHints();
    }

    #generateCellGridElements() {
        // generate cellGrid
        this.cellGridElements = [];

        const innerCalendarGridEl = document.querySelector('.inner-calendar-grid');

        let flatIdx = 0;

        for (let i = 0; i < 5; i++) {
            this.cellGridElements.push([]);

            const curWeekRowEl = document
              .createElement('div');

            curWeekRowEl.classList.add('week-row');
            innerCalendarGridEl.appendChild(curWeekRowEl);

            const cellGridRowElArr = this.cellGridElements[i];

            for (let j = 0; j < 7; j++) {

                const cellState = this.calendarState.cellGrid[i][j];

                const cellEl = document
                  .createElement('div');

                if (cellState.isInteractable) {
                    cellEl.classList.add('date');
                }
                else {
                    cellEl.classList.add('date');
                    cellEl.classList.add('date-fixed');

                    if (cellState.cellStatus !== CellStatusEnum.unoccupied) {
                        const fixedBorderEl = document.createElement('div');

                        fixedBorderEl.classList.add('date-inner-hint-border');

                        cellEl.appendChild(fixedBorderEl);
                    }
                }

                cellEl.setAttribute('data-cell-status', cellState.cellStatus);

                cellEl.setAttribute('data-animation', 'idle'); 

                cellEl.addEventListener('animationend', (ev) => cellEl.setAttribute('data-animation', 'idle'));

                const cellLabel = document
                  .createElement('div');
                
                cellLabel.classList.add('date-label');
                cellLabel.textContent = flatIdx < this.levelConfig.monthInfo.monthStartIdx1D
                  ? this.levelConfig.monthInfo.numDaysPrevMonth - (this.levelConfig.monthInfo.monthStartIdx1D - (flatIdx + 1))
                  : flatIdx >= (this.levelConfig.monthInfo.monthStartIdx1D + this.levelConfig.monthInfo.numDaysInMonth)
                    ? (flatIdx + 1)  -  (this.levelConfig.monthInfo.monthStartIdx1D + this.levelConfig.monthInfo.numDaysInMonth)
                    : (flatIdx + 1) - this.levelConfig.monthInfo.monthStartIdx1D;

                cellEl.appendChild(cellLabel);

                // TODO...eventListener
                if (cellState.isInteractable) {
                    cellEl.addEventListener('click', (e) => {
                        this.onCellLeftClicked(i,j);
                    });

                    cellEl.addEventListener('contextmenu', (e) => {
                        e.preventDefault();
                        this.onCellRightClicked(i,j);
                    });
                }

                // TODO...hint elements...
                if (cellState.cellStatus === CellStatusEnum.occupied) {
                    const occupiedOverlayEl = document.createElement('div');
                    occupiedOverlayEl.classList.add('occupied-overlay');

                    occupiedOverlayEl.addEventListener('animationend', (ev) => occupiedOverlayEl.setAttribute('data-animation', 'idle'));


                    cellEl.appendChild(occupiedOverlayEl);
                }
                else if (cellState.cellStatus === CellStatusEnum.rest) {
                    const restLabelEl = document.createElement('div');
                    restLabelEl.classList.add('rest-label');
                    restLabelEl.textContent = 'Zz';

                    restLabelEl.addEventListener('animationend', (ev) => restLabelEl.setAttribute('data-animation', 'idle'));


                    cellEl.appendChild(restLabelEl);
                }

                curWeekRowEl.appendChild(cellEl)

                cellGridRowElArr.push(cellEl);

                flatIdx++;
            }
        }
    }

    #generateDayOfWeekLabels() {
        // generate day of week label
        const dayOfWeekRow = document.querySelector('.day-of-week-label-row');

        const dayOfWeekLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        // should I keep hold this?
        for (let i = 0; i < 7; i++)
        {
            const labelName = dayOfWeekLabels[i];

            const labelElement = document
            .createElement('div');

            labelElement.textContent = labelName;
            labelElement.classList.add('day-of-week-label');

            dayOfWeekRow.appendChild(labelElement);
        }
    }

    #generateEdgeHints() {
        const weekHintsColEl = document.querySelector('.week-hints-col');

        const weekHintsArr = this.levelConfig.weekHintsArr;

        for (let i = 0; i < 5; i++) {
            const weekHint = weekHintsArr[i];

            const isUnspecifiedHint = weekHint == null;

            const weekHintEl = document.createElement('div');

            weekHintEl.classList.add('week-hint', 'border-hint');

            if (isUnspecifiedHint) {
                weekHintEl.textContent = '?'
            }
            else {
                // doesn't set the attribute, we do that in refresh render!
                weekHintEl.textContent = weekHint.toString();
            }

            weekHintsColEl.appendChild(weekHintEl);
        }

        this.weekHintsElArr = weekHintsColEl.children;

        const dayOfWeekHintsRowEl = document.querySelector('.day-of-week-hints-row');

        const dayOfWeekHintsArr = this.levelConfig.dayOfWeekHintsArr;

        for (let i = 0; i < 7; i++) {
            const dayOfWeekHint = dayOfWeekHintsArr[i];

            const isUnspecifiedHint = dayOfWeekHint == null;

            const dayOfWeekHintEl = document.createElement('div');

            dayOfWeekHintEl.classList.add('day-of-week-hint', 'border-hint');

            if (isUnspecifiedHint) {
                dayOfWeekHintEl.textContent = '?'
            }
            else {
                // doesn't set the attribute, we do that in refresh render!

                //dayOfWeekHintEl.setAttribute('data-hint', dayOfWeekHint);

                dayOfWeekHintEl.textContent = dayOfWeekHint;
            }

            dayOfWeekHintsRowEl.appendChild(dayOfWeekHintEl);
        }

        this.dayOfWeekHintsElArr = dayOfWeekHintsRowEl.children;

    }


}